import axios from 'axios';
import { sendNotificationUrl } from '../constants';
import { GuestCheckInRequest } from './types';

export const notifyResident = async (guest: GuestCheckInRequest) => {
  return await axios.post(sendNotificationUrl, guest);
};
